<div class="row mb-2">
  <div class="col-md-2" >
    <select [(ngModel)]="searchBy" class="form-control">
      <option value="">Select Search By</option>
      <option value="city">City</option>
    </select>
  </div>
  <div class="col-md-2">
    <input type="search"  [(ngModel)]="searchText" class="form-control mb-2 " placeholder="Search Text" > 
  </div>
  <div class="col-md-2">
    <button (click)="search()" class="btn btn-primary  btn-block" [disabled]="searchBy == ''" >Search <i class="fa fa-search"></i></button>
  </div>

        <div class="col-md-6 m-0 text-end">
          <button (click)="openAddCityModal(content5)" class="btn-shadow d-inline-flex align-items-center btn btn-success"> <fa-icon [icon]="faPlus" class="me-2"></fa-icon> Add City 
          </button>
          <button (click)="exportToExcel()" style="margin:0px 5px !important" class="btn-shadow  d-inline-flex align-items-center btn btn-success"><i class="fa fa-file-excel-o" aria-hidden="true"></i>
             Export Current Excel  </button>
             <button  class="btn-shadow d-inline-flex align-items-center btn btn-success"><i class="fa fa-file-excel-o" aria-hidden="true"></i>
              Export All Excel </button>
        </div>
    </div>
       
    
          <div class="main-card mb-3 card">
            <div class="card-header font-weight-B fs-1r">
              All Cities
            </div>
            <div class="table-responsive">
              <table class="align-middle mb-0 table table-borderless table-striped table-hover"  id="excel-table">
                <thead>
                <tr>
                  <!-- <th class="text-left" >#</th> -->
                  <th> Country</th>
                  <th>State</th>
                  <th>City</th>
                  <th>Activation</th>
                  <th class="text-end">Actions</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let data of allCitiesList | paginate : { itemsPerPage: itemsPerPage, currentPage: page, totalItems: totalItems  }">
                  <!-- <td class="text-left text-muted">#345</td> -->
                  <td>
                    <div class="widget-content p-0">
                      <div class="widget-content-wrapper">
                        <div class="widget-content-left flex2">
                          <div class="widget-heading">{{data.country}}</div>
                          <!-- <div class="widget-subheading opacity-7">Web Developer</div> -->
                        </div>
                      </div>
                    </div>
                  </td>
                  <td>
                    <div class="widget-content p-0">
                      <div class="widget-content-wrapper">
                        <div class="widget-content-left flex2">
                          <div class="widget-heading">{{data.state}}</div>
                          <!-- <div class="widget-subheading opacity-7">Web Developer</div> -->
                        </div>
                      </div>
                    </div>
                  </td>
                  <td>
                    <div class="widget-content p-0">
                      <div class="widget-content-wrapper">
                        <div class="widget-content-left flex2">
                          <div class="widget-heading">{{data.city}}</div>
                          <!-- <div class="widget-subheading opacity-7">Web Developer</div> -->
                        </div>
                      </div>
                    </div>
                  </td>
                  <td>
                    <div class="widget-content p-0">
                      <div class="widget-content-wrapper">
                        <div class="widget-content-left flex2">
                          <div class="widget-heading">
                            <label class="switch">
                                <input type="checkbox" (ngModelChange)="getVerifyToggleData($event , data)" [(ngModel)]="data.active">
                                <span class="slider round"></span>
                              </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </td>
                 
                  <td class="text-end">
                    <div class="dropdown">
                      <button class="btn btn-info dropdown-toggle" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                        Action
                      </button>
                      <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                        <li><a class="dropdown-item" (click)="editCity(content6 ,data)">Edit <i class="fa fa-pencil"></i></a></li>
                        <li><a class="dropdown-item" (click)="deleteCity( data)">Delete <i class="fa fa-trash"></i></a></li>
                      </ul>
                    </div>
                  </td>
                </tr>
               
                </tbody>
                <div *ngIf="allCitiesList?.length  == 0" class="text-center mt-5 mb-5" >
                  <span class="text-danger">Data Not found</span>
                </div>
                
              </table>
              <!-- <pagination-controls class="my-pagination" (pageChange)="gty((page = $event))"></pagination-controls> -->
              <ngb-pagination
              (pageChange)="gty((page = $event))"
              [collectionSize]="totalItems"
              [(page)]="page"
              [pageSize]="itemsPerPage"
              [maxSize]="3"
              [rotate]="true"
              [boundaryLinks]="false"
            >
            </ngb-pagination>
            </div>
          </div>




<div class="card-body">
    <ng-template #content5 let-c="close" let-d="dismiss">
      <div class="modal-header">
        <h4 class="modal-title"><fa-icon [icon]="faPlus" class="me-2"></fa-icon> Add City   </h4>
        <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')">
        </button>
      </div>
      <div class="modal-body">
        
        <div class="row">
            <div class="col-md-12">
              <label for="">City : </label>
              <input type="text" ngx-google-places-autocomplete (onAddressChange)="getCity($event)"  placeholder="Enter city" class="form-control">
           </div>
          </div>
          
          <div class="row mt-2 mb-2 text-center">
           <div class="col-md-12">
             <button  (click)="addCity()"  [disabled]=" city == ''" class="btn btn-primary btn-lg btn-block">Add City</button>
           </div>
         </div>

      </div>
      <!-- <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="c('Close click')">Close</button>
        <button type="button" class="btn btn-primary">Save changes</button>
      </div> -->
    </ng-template>
    <!-- <button class="btn btn-primary" (click)="open(content5)">Launch demo modal</button> -->
  </div>


  <div class="card-body">
    <ng-template #content6 let-c="close" let-d="dismiss">
      <div class="modal-header">
        <h4 class="modal-title"><i class="fa fa-pencil"></i> Edit City   </h4>
        <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')">
        </button>
      </div>
      <div class="modal-body">
     
        <div class="row">
          <div class="col-md-12">
            <label for="">ID : </label>
            <input type="text"   [(ngModel)]="editUserId"  [disabled]="true" class="form-control">
         </div>
        </div>
        
        <div class="row">
            <div class="col-md-12">
              <label for="">City : </label>
              <input type="text" ngx-google-places-autocomplete (onAddressChange)="getCity($event)"  [(ngModel)]="editCityName"  placeholder="Enter city" class="form-control">
           </div>
          </div>
          
          <div class="row mt-2 mb-2 text-center">
           <div class="col-md-12">
             <button  (click)="updateCity()"  [disabled]=" editCityName == ''" class="btn btn-primary btn-lg btn-block">Update City</button>
           </div>
         </div>

      </div>
      <!-- <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="c('Close click')">Close</button>
        <button type="button" class="btn btn-primary">Save changes</button>
      </div> -->
    </ng-template>
    <!-- <button class="btn btn-primary" (click)="open(content5)">Launch demo modal</button> -->
  </div>